(function () {
  'use strict';
  if (window.__csMenAppointment) return;
  window.__csMenAppointment = true;
  var instances = new Map();
  var allowedCodes = ['wedding_ceremony', 'event', 'business', 'other'];
  function node(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }
  function arrow() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M4 12h16m-6-6 6 6-6 6');
    path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.3');
    svg.appendChild(path); return svg;
  }
  function emit(control, type) { control.dispatchEvent(new Event(type, { bubbles: true })); }
  function displayTranslation(key, value) {
    if (typeof value !== 'string' || key === 'url' || key === 'privacyUrl') return value;
    var entities = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&#34;': '"', '&#x22;': '"' };
    return value.replace(/&(?:amp|lt|gt|quot|#39|#x27|#34|#x22);/g, function (entity) { return entities[entity]; });
  }
  function setup(root, form, context) {
    if (form.dataset.csMenAppointment === '1' || form.dataset.csCerUx === '1' || form.dataset.csPgUx === '1') return null;
    var fieldset = form.querySelector('.fieldset');
    var data = context.querySelector('[data-cs-men-appointment-i18n]');
    if (!fieldset || !data || form.dataset.csFormId !== 'appointment_men' || form.dataset.csLeadLinePreset !== 'men') return null;
    var cfg; try { cfg = JSON.parse(data.textContent, displayTranslation); } catch (_) { return null; }
    var abort = new AbortController(), undo = [];
    function listen(target, type, handler, capture) { target.addEventListener(type, handler, { signal: abort.signal, capture: !!capture }); }
    function rememberAttribute(element, key, value) {
      var old = element.getAttribute(key);
      undo.push(function () { if (old == null) element.removeAttribute(key); else element.setAttribute(key, old); });
      if (value == null) element.removeAttribute(key); else element.setAttribute(key, value);
    }
    function changeText(element, text) {
      if (!element || text == null) return;
      var original = Array.from(element.childNodes); element.textContent = text;
      undo.push(function () { element.replaceChildren.apply(element, original); });
    }
    function add(element, parent, before) {
      parent.insertBefore(element, before || null); undo.push(function () { element.remove(); }); return element;
    }
    function move(element, parent, before) {
      if (!element) return;
      var placeholder = document.createComment('cs-men-field-position');
      element.before(placeholder); parent.insertBefore(element, before || null);
      undo.push(function () { placeholder.replaceWith(element); });
    }
    function field(control) { return control && control.closest('.form-control'); }
    function label(control, text, placeholder) {
      if (!control) return;
      var wrapper = field(control);
      if (wrapper) changeText(wrapper.querySelector('label'), text);
      if (placeholder != null) rememberAttribute(control, 'placeholder', placeholder);
    }
    rememberAttribute(form, 'data-cs-men-appointment', '1');
    var inName = form.querySelector('[name="contact[name]"]');
    var inPhone = form.querySelector('[name="contact[Telefon]"], [name="contact[Phone]"], [name="contact[phone]"]');
    var inEmail = form.querySelector('[name="contact[email]"]');
    var showroom = form.querySelector('select[name="contact[showroom]"]');
    var occasion = form.querySelector('select[name="cs_ui_lead_occasion"]');
    var line = form.querySelector('select[name="cs_ui_lead_line"]');
    var submit = form.querySelector('button[type="submit"]');
    var section = form.closest('.shopify-section');
    var header = section.querySelector('.section-header');
    if (header) {
      changeText(header.querySelector('h2'), cfg.title);
      var prose = header.querySelector('.prose');
      if (prose) {
        var intro = Array.from(prose.querySelectorAll('p')).find(function (p) { return !p.classList.contains('h6'); });
        if (intro) changeText(intro, cfg.intro); else add(node('p', '', cfg.intro), prose);
      }
    }
    var title = context.querySelector('[data-cs-men-selected-title]');
    if (root.dataset.productTitle) changeText(title, root.dataset.productTitle);
    label(inName, cfg.name, cfg.namePlaceholder);
    label(inPhone, cfg.phone, cfg.phonePlaceholder);
    label(inEmail, cfg.email, cfg.emailPlaceholder);
    label(occasion, cfg.occasion);
    var row = add(node('div', 'cs-men-form-row'), fieldset, fieldset.firstChild);
    move(field(inName), row); move(field(inPhone), row);
    var after = row;
    [field(inEmail), field(showroom), field(occasion), field(line)].forEach(function (control) {
      if (!control) return;
      move(control, fieldset, after.nextSibling); after = control;
    });
    if (line && line.value === 'men') rememberAttribute(field(line), 'hidden', '');
    var validOccasions = (root.dataset.occasions || '').split(',').filter(function (code) { return allowedCodes.indexOf(code) !== -1; });
    if (occasion) {
      Array.from(occasion.options).forEach(function (option) {
        if (!option.value) { changeText(option, cfg.occasionPlaceholder); return; }
        if (cfg.occasionLabels[option.value]) changeText(option, cfg.occasionLabels[option.value]);
        if (validOccasions.length && validOccasions.indexOf(option.value) === -1) {
          rememberAttribute(option, 'disabled', ''); rememberAttribute(option, 'hidden', '');
        }
      });
      if (validOccasions.length && occasion.value && validOccasions.indexOf(occasion.value) === -1) occasion.value = '';
      if (!occasion.value && root.dataset.occasion && validOccasions.indexOf(root.dataset.occasion) !== -1) occasion.value = root.dataset.occasion;
      var real = Array.from(occasion.options).filter(function (option) { return option.value && !option.disabled; });
      if (real.length === 1) {
        if (!occasion.value) occasion.value = real[0].value;
        rememberAttribute(field(occasion), 'hidden', '');
        var interest = node('div', 'cs-men-interest');
        interest.appendChild(node('span', 'cs-men-field-label', cfg.interest));
        interest.appendChild(node('p', '', real[0].textContent));
        add(interest, fieldset, field(occasion));
      }
    }
    var syncShowroom = function () {};
    if (showroom) {
      var srField = field(showroom);
      var group = node('div', 'cs-men-city-grid');
      var legend = node('p', 'cs-men-field-label', cfg.showroom);
      legend.id = 'cs-men-showroom-label-' + form.id;
      group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-labelledby', legend.id);
      group.setAttribute('aria-required', 'true');
      var error = node('p', 'cs-men-field-error', cfg.showroomError); error.hidden = true;
      error.id = 'cs-men-showroom-error-' + form.id; group.setAttribute('aria-describedby', error.id);
      var buttons = [];
      ['bucuresti', 'constanta', 'cluj', 'timisoara'].forEach(function (code) {
        var option = Array.from(showroom.options).find(function (o) { return o.value === code && !o.disabled; });
        if (!option) return;
        var room = cfg.showrooms[code];
        var button = node('button', 'cs-men-city', room ? room.name : option.textContent);
        button.type = 'button'; button.dataset.value = code; button.setAttribute('role', 'radio');
        group.appendChild(button); buttons.push(button);
      });
      if (buttons.length) {
        add(legend, srField, srField.firstChild); add(group, srField); add(error, srField);
        var detail = node('div', 'cs-men-showroom-address'); detail.setAttribute('role', 'status'); detail.setAttribute('aria-live', 'polite');
        var address = node('p'); var locationLink = node('a', '', cfg.location);
        locationLink.target = '_blank'; locationLink.rel = 'noopener noreferrer'; locationLink.appendChild(arrow());
        detail.appendChild(address); detail.appendChild(locationLink); add(detail, srField);
        rememberAttribute(srField, 'data-cs-men-showroom', '1');
        rememberAttribute(showroom, 'tabindex', '-1'); rememberAttribute(showroom, 'aria-hidden', 'true');
        syncShowroom = function () {
          var value = showroom.value, match = buttons.find(function (button) { return button.dataset.value === value; });
          buttons.forEach(function (button, index) {
            var selected = button === match;
            button.setAttribute('aria-checked', String(selected)); button.tabIndex = selected || (!match && index === 0) ? 0 : -1;
          });
          var room = cfg.showrooms[value]; detail.hidden = !room;
          if (room) { address.textContent = room.address; locationLink.href = room.url; }
          else locationLink.removeAttribute('href');
          if (match) { error.hidden = true; group.removeAttribute('aria-invalid'); }
        };
        function choose(button) {
          if (showroom.value !== button.dataset.value) {
            showroom.value = button.dataset.value; emit(showroom, 'input'); emit(showroom, 'change');
          }
          syncShowroom(); button.focus({ preventScroll: true });
        }
        listen(group, 'click', function (event) {
          var button = event.target.closest('button'); if (buttons.indexOf(button) === -1) return;
          choose(button);
        });
        listen(group, 'keydown', function (event) {
          var index = buttons.indexOf(document.activeElement); if (index < 0) return;
          var delta = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (delta == null && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + delta + buttons.length) % buttons.length;
          choose(buttons[next]);
        });
        listen(showroom, 'input', syncShowroom); listen(showroom, 'change', syncShowroom);
        listen(showroom, 'invalid', function (event) {
          event.preventDefault(); error.hidden = false; group.setAttribute('aria-invalid', 'true');
          if (form.querySelector('input:invalid,select:invalid,textarea:invalid') === showroom) buttons[0].focus({ preventScroll: false });
        });
        syncShowroom();
      }
    }
    if (submit) {
      var labelNode = Array.from(submit.childNodes).find(function (child) { return child.nodeType === 3 && child.textContent.trim(); });
      if (labelNode) {
        var oldText = labelNode.textContent; labelNode.textContent = cfg.submit;
        undo.push(function () { labelNode.textContent = oldText; });
      } else {
        var submitText = submit.querySelector('[data-cs-men-submit-text]');
        if (submitText) changeText(submitText, cfg.submit);
      }
      add(arrow(), submit);
      add(node('p', 'cs-men-confirmation', cfg.confirmation), submit.parentNode, submit.nextSibling);
    }
    var heading = header && header.querySelector('h2');
    if (heading) {
      rememberAttribute(heading, 'tabindex', '-1');
      listen(document, 'click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target.closest && event.target.closest('a[href]'); if (!link) return;
        var destination; try { destination = new URL(link.href, location.href); } catch (_) { return; }
        if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
        var target; try { target = document.getElementById(decodeURIComponent(destination.hash.slice(1))); } catch (_) { return; }
        if (!target || (target !== form && !form.contains(target))) return;
        requestAnimationFrame(function () {
          if (!abort.signal.aborted && !form.querySelector('.cs-appt-success:not([hidden])')) heading.focus({ preventScroll: true });
        });
      });
    }
    listen(form, 'reset', function () { setTimeout(function () { if (!abort.signal.aborted) syncShowroom(); }, 0); });
    return {
      form: form, context: context,
      sync: syncShowroom,
      cleanup: function () { abort.abort(); undo.reverse().forEach(function (restore) { restore(); }); }
    };
  }
  function init() {
    instances.forEach(function (instance, root) {
      if (!root.isConnected || !instance.form.isConnected || !instance.context.isConnected) { instance.cleanup(); instances.delete(root); }
    });
    document.querySelectorAll('[data-cs-men-product]').forEach(function (root) {
      if (instances.has(root)) { instances.get(root).sync(); return; }
      var section = root.closest('.shopify-section');
      var context = section && section.querySelector('[data-cs-men-appointment-context]');
      var next = section && section.nextElementSibling;
      var form = next && next.querySelector('form[data-cs-lead-form]');
      if (!context || !form) return;
      var instance = setup(root, form, context);
      if (instance) instances.set(root, instance);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, root) {
      if (event.target.contains(root) || event.target.contains(instance.form)) { instance.cleanup(); instances.delete(root); }
    });
  });
  window.addEventListener('pageshow', init);
})();
